import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_RESTAURANT_SETTINGS_SUCCESS,
    LOAD_ORDER_TYPES_SUCCESS,
    UPDATE_RESTAURANT_SETTINGS_SUCCESS,
    CLEAR_RESTAURANT_SETTINGS,
    CLEAR_ORDER_TYPES
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import { getRestaurantLevelPromoProvider } from '../../../index';

export const loadOrderTypes = () => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/order-type`;

        axios().get(url)
            .then(response => loadOrderTypesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:generalServicesActions.loadOrderTypesFailure')));
    }
}

const loadOrderTypesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_ORDER_TYPES_SUCCESS, payload: response.data });
};

export const loadRestaurantSettings = (restaurantId) => {
    return (dispatch, getState) => {
        if (Number(restaurantId) !== -1) {
            doLoadRestaurantSettings(dispatch, getState, restaurantId);
        }
    }
}

export const doLoadRestaurantSettings = (dispatch, getState, restaurantId) => {

    const url = `/restaurant-settings/${restaurantId}/general-order-settings`;

    axios().get(url)
        .then(response => loadRestaurantSettingsSuccess(dispatch, response, restaurantId))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:generalServicesActions.loadDataFailure')));
}

const loadRestaurantSettingsSuccess = (dispatch, response, restaurantId) => {

    dispatch(getRestaurantLevelPromoProvider(restaurantId));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANT_SETTINGS_SUCCESS, payload: response.data });
}

export const updateRestaurantSettings = (restaurantId, state, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-settings/${restaurantId}/general-order-settings`;

        const generalOrderSettings = {
            orderTypes: state.orderTypes,
            defaultOrderType: state.defaultOrderType,
            defaultPreparationTime: state.defaultPreparationTime,
            preparationTimes: state.preparationTimes,
            tipsEnabled: state.tipsEnabled,
            minimumDeliveryTip:
                (!state.tipsEnabled || state.minimumDeliveryTip === undefined || state.minimumDeliveryTip === null ||
                    state.minimumDeliveryTip === '') ? null : Number(state.minimumDeliveryTip),
            deliveryTipInPercentage: state.deliveryTipInPercentage,
            disableFutureOrders: state.disableFutureOrders,
            futureOrdersLimit:
                (state.futureOrdersLimit === undefined || state.futureOrdersLimit === null ||
                    state.futureOrdersLimit === '') ? null : Number(state.futureOrdersLimit),
            enableSmsOrderNotification: state.enableSmsOrderNotification,
            autoConfirmOrders: state.autoConfirmOrders,
            deferFutureOrder: state.deferFutureOrder,
            phone: state.phone,
            generalNote: state.generalNote,
            emailConfirmationNote: state.emailConfirmationNote,
            removedConfirmationSMS: state.removedConfirmationSMS,
            timeSlotBased: state.timeSlotBased,
            timeSlotBufferTime: state.timeSlotBufferTime,
            additionalFireTime: state.additionalFireTime === '0' ? null : state.additionalFireTime,
            additionalMoneyCookTimes: state.additionalMoneyCookTimes,
            showMenuuLogo: state.showMenuuLogo,
            enableLargeImageDesign: state.enableLargeImageDesign
        }

        if (state.defaultPreparationTime == null) {
            MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:generalServicesActions.noneOrMissingDefaultPreparationTime'));
            return;
        }

        if (state.orderTypes.length > 0) {
            for (let i = 0; i < state.orderTypes.length; i++) {

                if (state.orderTypes[i].id == state.defaultOrderType.id) {
                    return axios().put(url, generalOrderSettings)
                        .then(response => updateRestaurantSettingsSuccess(dispatch, response, callback))
                        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')))
                } else if ((state.orderTypes.length - 1) == i) {
                    //This message will appear only if ALL elements doesn't pass the check
                    MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:generalServicesActions.noneOrMissingOrderTypes'));
                }
            }
        } else {
            MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:generalServicesActions.noneOrMissingOrderTypes'));
        }
    }
}

const updateRestaurantSettingsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_RESTAURANT_SETTINGS_SUCCESS, payload: response.data });
    if (callback) {
        callback()
    }

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
}

export const clearRestaurantSettings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_RESTAURANT_SETTINGS });
    }
};

export const clearOrderTypes = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_ORDER_TYPES });
    }
};

export const invalidSurveyGiftCardPartnerFormMessage = () => dispatch => {
    console.log( i18n.t('screens:generalServicesActions.giftCardSurveyPartnerEmptyFields'));
    MessageUtils.errorMessageResponse(dispatch, '', i18n.t('actions:generalServicesActions.giftCardSurveyPartnerEmptyFields'));
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/GeneralServicesActions.js